module.exports = __webpack_public_path__ + "static/p13_bacerroCabeza-32eb7453bcc469731b83c7e3478580cf.png";